import React from 'react';
import PropTypes from 'prop-types';

import { InfoText } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Seat } from '@weezevent/throne/dist/images/seating/siege-available.svg';

import Style from './swapSeatItem.module.css';
import { InfoTextTooltip } from '../../detail/components/infotext-tooltip/infoTextTooltip';

function Title({ attendee = {}, index = 0 }) {
    if (!attendee) {
        return null;
    }

    return (
        <div>
            <div className={Style['title']}>
                <style>
                    {`
                        svg.seat-category-edit {
                            width: '25px';
                            height: '23px';
                            margin-right: 3px;
                        }

                        svg.seat-category-edit-${attendee.booking.rate_category_color.substring(1, attendee.booking.rate_category_color.length)} path {
                            fill: ${attendee.booking.rate_category_color};
                        }
                    `}
                </style>
                <div>
                    <Seat
                        className={`seat-category-edit ${'seat-category-edit-' + attendee.booking.rate_category_color.substring(1, attendee.booking.rate_category_color.length)}`}
                    />
                </div>
                <InfoTextTooltip className={Style['infotext-name']} title={attendee.resolved_attendee_name} />
            </div>
            <div className={Style['seat-index']}>{index + 1}</div>
        </div>
    );
}

Title.propTypes = {
    attendee: PropTypes.object,
    index: PropTypes.number
};

function SubLabelSeating({ seating = {}, newSeating = false }) {
    const { t } = useTranslation();

    if (!seating) {
        return null;
    }

    //Check free seating
    if (!seating.seat_uuid && seating.area_zone) {
        return <span>{t('ticket.common.seating.freeSeating')}</span>;
    }

    return (
        <span
            // key for render highlight after edit
            key={`${seating.seat_access || seating.access} ${seating.seat_row || seating.row} ${seating.seat_seat || seating.seat}`}
            className={newSeating ? Style['sub-label'] : ''}
        >
            <span>{seating.seat_zone_name || seating.zone_name}</span>
            <span className={Style['inline']}>
                {t('ticket.common.seating.labelInfosSeating', {
                    seat: seating.seat_seat || seating.seat,
                    row: seating.seat_row || seating.row,
                    access: seating.seat_access || seating.access
                })}
            </span>
            {seating.seat_grandstand && (
                <>
                    <span className={Style['inline']}>{t('ticket.common.seating.grandstand')}</span>
                    {` • ${seating.seat_grandstand}`}
                </>
            )}
        </span>
    );
}

SubLabelSeating.propTypes = {
    seating: PropTypes.object,
    newSeating: PropTypes.bool
};

function LabelSeating({ seating = {}, newSeating = false }) {
    const { t } = useTranslation();

    return (
        <InfoText
            lineBreak
            className={!newSeating ? Style['label-seating'] : Style['label-new-seating']}
            subtitle={newSeating && !seating ? t('ticket.swapSeat.list.placeholderSeating') : <SubLabelSeating newSeating={newSeating} seating={seating} />}
        >
            {newSeating ? t('ticket.swapSeat.list.labelNewSeating') : t('ticket.swapSeat.list.labelCurrentSeating')}
        </InfoText>
    );
}

LabelSeating.propTypes = {
    seating: PropTypes.object,
    newSeating: PropTypes.bool
};

export default function SwapSeatItem({ attendee = null, onClick = () => {}, className = '', selected = false, ...rest }) {
    if (!attendee) {
        return null;
    }

    return (
        <div className={`${Style['swap-seat-item']} ${selected ? Style['selected'] : ''} ${className}`} onClick={() => onClick(attendee)} {...rest}>
            <Title attendee={attendee.attendee} index={attendee.index} />
            <LabelSeating seating={attendee.attendee.booking} />
            <LabelSeating seating={attendee.new_seat} newSeating />
        </div>
    );
}

SwapSeatItem.propTypes = {
    attendee: PropTypes.object,
    className: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};
